"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Checkbox: true
};
exports.default = exports.Checkbox = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _ValidationTooltip = require("../Tooltip/_ValidationTooltip");
var _messages = require("../utils/messages");
var _console = _interopRequireDefault(require("../utils/console"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _Checkbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Checkbox.css") : void 0);
var _Checkbox2 = require("./Checkbox.types");
Object.keys(_Checkbox2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Checkbox2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Checkbox2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-checkbox';
/** **Checkbox** is a specialized form control that emits an
 * `<input>` with a type of checkbox. */
const Checkbox = exports.Checkbox = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Checkbox, _props)) : _props;
  const {
      checked,
      className,
      disabled,
      hiddenLabel,
      indeterminate,
      inline,
      inputProps,
      label,
      labelProps,
      onChange,
      required,
      validationMessage,
      inputRef,
      isControlled,
      innerTextClassName
    } = props,
    otherProps = __rest(props, ["checked", "className", "disabled", "hiddenLabel", "indeterminate", "inline", "inputProps", "label", "labelProps", "onChange", "required", "validationMessage", "inputRef", "isControlled", "innerTextClassName"]);
  const localInputRef = (0, _react.useRef)(null);
  const classnames = _bind.default.bind(_Checkbox.default);
  const classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, className, {
    [`${CSS_BLOCK}--disabled`]: disabled,
    [`${CSS_BLOCK}--inline`]: inline,
    [`${CSS_BLOCK}--${validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state}`]: !!validationMessage
  });
  const inputClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__input`, {
    [`${CSS_BLOCK}__input--indeterminate`]: indeterminate
  }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className);
  (0, _useUniversalLayoutEffect.default)(() => {
    if (!localInputRef.current) {
      return;
    }
    if (indeterminate) {
      localInputRef.current.indeterminate = true;
    } else {
      localInputRef.current.indeterminate = false;
    }
  });
  let ariaLabel;
  if (!hiddenLabel && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text)) {
    ariaLabel = `${label} ${validationMessage.text}`;
  }
  if (hiddenLabel && required) {
    _console.default.warn(_messages.ELEMENT_VALIDATION_WARNINGS.CHECKBOX_HIDDEN_LABEL_REQUIRED);
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _react.default.createElement("label", Object.assign({}, otherProps, labelProps, {
      className: classes,
      ref: ref
    }), /*#__PURE__*/_react.default.createElement("input", Object.assign({}, inputProps, {
      "aria-label": ariaLabel,
      checked: isControlled ? !!checked : checked,
      className: inputClasses,
      disabled: disabled,
      onChange: e => {
        onChange === null || onChange === void 0 ? void 0 : onChange(!checked, e);
      },
      ref: (0, _reactMergeRefs.default)([localInputRef, inputRef, inputProps === null || inputProps === void 0 ? void 0 : inputProps.ref]),
      required: required,
      type: "checkbox"
    })), (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state) && (/*#__PURE__*/_react.default.createElement(_ValidationTooltip.ValidationTooltip, {
      state: validationMessage.state,
      text: validationMessage.text,
      targetClassName: classnames(`${CSS_BLOCK}__validation`)
    })), hiddenLabel ? (/*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}--screen-reader-only`)
    }, label, " ", validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text)) : (/*#__PURE__*/_react.default.createElement("span", {
      className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__label`, innerTextClassName)
    }, label)), !disabled && required && (/*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__required`)
    }, "*")))
  );
});
Checkbox.displayName = 'Checkbox';
var _default = exports.default = Checkbox;